// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HYTt","clinicsSelect":"styles_clinicsSelect__CMicB"};